<template>
  <div>
    <div class="headerBg">
      <van-row style="padding: 15px 0px">
        <van-col span="5" class="headerItem">
          <router-link to="/info/guide">
            <div class="headerTop">
              <img src="../views/images/common/Guide.png" class="headerImg" />
              <p class="headerItemText">{{ $t("guide.guide") }}</p>
            </div>
          </router-link>
        </van-col>
        <van-col span="5" class="headerItem">
          <div class="headerTop">
            <a
              href="https://afmboxoffice.com/"
              target="_blank"
              class="headerTop"
            >
              <img src="../views/images/common/About.png" class="headerImg" />
              <p class="headerItemText">{{ $t("about.about") }}</p>
            </a>
          </div>
        </van-col>
        <van-col span="5" class="headerItem">
          <div class="headerTop">
            <a
              href="https://www.boxofficemojo.com/year/world/?ref_=bo_nb_hm_tab"
              target="_blank"
              class="headerTop"
            >
              <img src="../views/images/common/Mojo.png" class="headerImg" />
              <p class="headerItemText">{{ $t("mojo.mojo") }}</p>
            </a>
          </div>
        </van-col>
        <van-col span="5" class="headerItem">
          <div class="headerTop" @click="$router.push('/language')">
            <img src="../views/images/common/Lang.png" class="headerImg" />
            <p class="headerItemText">{{ $t("header.language")}}</p>
          </div>
        </van-col>
        <van-col span="4" class="headerItem">
          <div class="headerTop">
            <a 
              href="https://t.me/naomiafm"
              target="_blank"
              class="headerTop"
            >
              <img
                src="../views/images/common/CustomerService.png"
                class="headerImg"
              />
              <p class="headerItemText">{{ $t("header.customerSupport")}}</p>
            </a>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Col, Row } from "vant";
Vue.use(Row).use(Col);
export default {
  name: "Header",
  data() {
    return {};
  },
  computed: {},
  methods: {
    nav() {},
    mounted: function () {},
  },
};
</script>


<style scoped>
.headerBg {
  background: url("../views/images/common/HeaderBg.png");
  background-size: 100% 100%;
}

.headerItem {
  align-items: center;
  display: flex;
  justify-content: center;
}

.headerImg {
  width: 18px;
}

.headerItemText {
  color: #ffffff;
  font-size: 14px;
  padding-left: 6px;
}

.headerTop {
  display: flex;
  align-items: center;
}
</style>


